import { render, staticRenderFns } from "./EditSnsSelectBox.vue?vue&type=template&id=01a629e2&scoped=true&"
import script from "./EditSnsSelectBox.vue?vue&type=script&lang=js&"
export * from "./EditSnsSelectBox.vue?vue&type=script&lang=js&"
import style0 from "./EditSnsSelectBox.vue?vue&type=style&index=0&id=01a629e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a629e2",
  null
  
)

export default component.exports